/**
 * Product carousel: horizontal scroll via prev/next arrows.
 * Runs per [data-product-carousel] container. Uses [data-carousel-track] and data-carousel-prev / data-carousel-next.
 */
function initProductCarousel(section) {
  const track = section.querySelector('[data-carousel-track]');
  const prevBtn = section.querySelector('[data-carousel-prev]');
  const nextBtn = section.querySelector('[data-carousel-next]');

  if (!track || (!prevBtn && !nextBtn)) return;

  const cards = section.querySelectorAll('[data-carousel-card]');
  if (cards.length === 0) return;

  const cardWidth = cards[0].offsetWidth;
  const gap = 16;
  const step = cardWidth + gap;

  function scrollBy(direction) {
    const current = track.scrollLeft;
    const next = direction === 'next' ? current + step : current - step;
    track.scrollTo({ left: Math.max(0, next), behavior: 'smooth' });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', () => scrollBy('prev'));
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', () => scrollBy('next'));
  }
}

function initProductCarousels() {
  document.querySelectorAll('[data-product-carousel]').forEach((section) => {
    if (section.querySelector('[data-carousel-track]')) {
      initProductCarousel(section);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductCarousels);
} else {
  initProductCarousels();
}
